// removed by extract-text-webpack-plugin
module.exports = {"tag":"styles__tag___3ZkjB","tagLabel":"styles__tagLabel___1J-B9","moreLink":"styles__moreLink___293gJ"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/tags/styles.css
// module id = 1HGh
// module chunks = 2